import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "weak_pwd",
  "use": "weak_pwd-usage",
  "viewBox": "0 0 12 15.75",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 15.75\" id=\"weak_pwd\"><path d=\"M11.4 6.75H2.75v-2a3.25 3.25 0 016.5 0v1h1.5v-1a4.75 4.75 0 00-9.5 0v2H.6a.6.6 0 00-.6.6v7.8a.6.6 0 00.6.6h10.8a.6.6 0 00.6-.6v-7.8a.6.6 0 00-.6-.6zm-4.71 4.32v2.23a.69.69 0 01-1.38 0v-2.23a1.38 1.38 0 111.38 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id